<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import AuCallout from '~/components/ui/AuCallout.vue'

const props = defineProps<{
  statusCode: number
}>()

const { t } = useI18n()

const message = computed(() => {
  switch (props.statusCode) {
    case 400:
      return t('register.error.invalidInput')
    case 409:
      return t('register.error.alreadyExists')
    default:
      return t('register.error.internal')
  }
})
</script>

<template>
  <AuCallout
    variant="error"
    class="mb-4"
    :title="message"
  />
</template>
